<template>
  <div class="border-2 border-grey-border p-12 mt-4">
    <div class="flex justify-between">
      <div>
        <div class="h7">{{ signedDocument.title }}</div>
        <div>
          {{ $t("signedDocuments.created_at") + " " + $h.formatDate(signedDocument.created_at, timezone, false, true) }}
          |
          {{ $t("signedDocuments.expire_at") + " " + $h.formatDate(signedDocument.expire_at, timezone, false, true) }}
        </div>
        <div>{{ $t("signedDocuments.status") + " " + currentStatus }}</div>
        <div v-if="signingPartOne">
          {{
            $t("signedDocuments.signer.type." + signingPartOne.type) +
            " " +
            $t("signedDocuments.signer.status." + (signingPartOne.signed ? "true" : "false"))
          }}
        </div>
        <div v-if="signingPartTwo">
          {{
            $t("signedDocuments.signer.type." + signingPartTwo.type) +
            " " +
            $t("signedDocuments.signer.status." + (signingPartTwo.signed ? "true" : "false"))
          }}
        </div>
      </div>
      <div class="relative">
        <div class="btn success round icon small" v-if="isSigned">
          <v2-icon :data="require('@icon/Icon=check.svg')"></v2-icon>
        </div>
        <div class="btn danger round icon small" v-if="isCanceled || isExpired">
          <v2-icon :data="require('@icon/Icon=x.svg')"></v2-icon>
        </div>
        <v-button
          v-if="!isSigned && !isCanceled && !isExpired"
          icon
          secondary
          round
          small
          @click.stop.native="$eventbus.$emit('toggleDropdown', signedDocument.uid)"
        >
          <v2-icon :data="require('@icon/Icon=more-horizontal.svg')"></v2-icon>
        </v-button>
        <v-dropdown
          :dropdownUid="signedDocument.uid"
          :data="signedDocumentMoreDropdown"
          right
          small
          :value="signedDocument"
        >
        </v-dropdown>
      </div>
    </div>
    <ul class="list mt-4">
      <signed-document-list-item
        v-for="file in files"
        :key="'signedDocumentfile_' + file.uid"
        class="cursor-pointer"
        :file="file"
        :moreDropdown="signedDocumentFileMoreDropdown"
        :moreDropdownWithDisabled="signedDocumentFileMoreDropdownWithDisabled"
        :timezone="timezone"
        :statiBits="statiBits"
        @downloadFile="downloadFile({ file: file, document: signedDocument.uid })"
        :getSelf="getSignedDocumentFile"
        :getPreview="getSignedDocumentFilePreview"
        :currentProject="currentProject"
        :documentIsEditable="isNew || isReadyToSign"
        :currentDocument="signedDocument.uid"
        :team="$route.params.team"
      >
      </signed-document-list-item>
      <v-list-item v-if="!files.length">
        <v-list-cell :value="$t('signedDocuments.noSignedDocumentFiles')"></v-list-cell>
      </v-list-item>
    </ul>
    <a :id="'signingUrl_' + signedDocument.uid" href="" class="v1 hidden" target="_blank"></a>
  </div>
</template>

<script>
import SignedDocumentListItem from "@/views/partials/SignedDocumentListItem";

export default {
  name: "SignedDocumentItem",
  components: {
    SignedDocumentListItem,
  },
  props: {
    currentProject: {
      type: String,
      required: true,
    },
    signedDocument: {
      type: Object,
      default: () => {
        return {};
      },
    },
    files: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getSelf: {
      type: Function,
      default: () => {},
    },
    team: {
      type: Object,
      default: () => {},
    },
    timezone: {
      type: String,
      default: "",
    },
    statiBits: {
      type: Object,
      default: function () {
        return {};
      },
    },
    signedDocumentStatiBits: {
      type: Object,
      default: function () {
        return {};
      },
    },
    signedDocumentFileMoreDropdown: {
      type: Array,
      default: () => {
        return [];
      },
    },
    signedDocumentFileMoreDropdownWithDisabled: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getSignedDocumentFile: {
      type: Function,
      default: () => {},
    },
    getSignedDocumentFilePreview: {
      type: Function,
      default: () => {},
    },
    addFiles: {
      type: Function,
      default: () => {},
    },
    deleteDocument: {
      type: Function,
      default: () => {},
    },
    downloadFile: {
      type: Function,
      default: () => {},
    },
    startSigningProcess: {
      type: Function,
      default: () => {},
    },
    redirectToSigningPage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      item: {},
      amountTry: 10,
      timeWaitStart: 15000,
      timer: null,
    };
  },
  created() {
    this.item = this.signedDocument;
    if (this.isInitSigningProcess && !this.isWaitingOnSignatures) this.untilReady();
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    untilReady(restart = false) {
      const data = {
        document: this.signedDocument.uid,
        project: this.currentProject,
        customLoading: true,
      };
      if (!this.isWaitingOnSignatures || restart) {
        const vm = this;
        vm.timer = setTimeout(function () {
          vm.getSelf(data)
            .then((response) => {
              vm.item = response;
              vm.amountTry = vm.amountTry - 1;
              if (vm.amountTry <= 0) {
                vm.amountTry = 10;
                vm.timeWaitStart = vm.timeWaitStart + 60000;
              }
              vm.untilReady();
            })
            .catch();
        }, vm.timeWaitStart);
      }
    },
    isNewCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.NEW.bit)
        : false;
    },
    isReadyToSignCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.READY_TO_SIGN.bit)
        : false;
    },
    isInitSigningProcessCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.INIT_SIGNING.bit)
        : false;
    },
    isWaitingOnSignaturesCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.WAITING_ON_SIGNATURES.bit)
        : false;
    },
    isSignedCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.SIGNED.bit)
        : false;
    },
    isCanceledCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.CANCELED.bit)
        : false;
    },
    isExpiredCalculate(item) {
      return this.signedDocumentStatiBits && item
        ? this.$h.globalIsBitSet(item.status, this.signedDocumentStatiBits.EXPIRED.bit)
        : false;
    },
    thisStartSigningProcess(data) {
      this.startSigningProcess(data);
      this.untilReady();
    },
    thisRestartSigningProcess(data) {
      this.startSigningProcess(data);
      this.untilReady(true);
    },
  },
  computed: {
    signingPartOne() {
      return this.signedDocument.signer.find((o) => o.step === 1);
    },
    signingPartTwo() {
      return this.signedDocument.signer.find((o) => o.step === 2);
    },
    isNew() {
      return this.isNewCalculate(this.item);
    },
    isReadyToSign() {
      return this.isReadyToSignCalculate(this.item);
    },
    isInitSigningProcess() {
      return this.isInitSigningProcessCalculate(this.item);
    },
    isWaitingOnSignatures() {
      return this.isWaitingOnSignaturesCalculate(this.item);
    },
    isSigned() {
      return this.isSignedCalculate(this.item);
    },
    isCanceled() {
      return this.isCanceledCalculate(this.item);
    },
    isExpired() {
      return this.isExpiredCalculate(this.item);
    },
    isFinished() {
      return this.isSigned || this.isCanceled || this.isExpired;
    },
    currentStatus() {
      return this.signedDocumentStatiBits && this.item
        ? this.$h.globalGetCurrentSignedDocumentStatus(this.item.status, this.signedDocumentStatiBits)
        : "";
    },
    showSignAction() {
      return this.team.account.team.attributes.signed_documents.providers[this.signedDocument.provider]
        .show_sign_action;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    signedDocumentMoreDropdown: function () {
      if (this.$h.globalIsBitSet(this.item.status, this.signedDocumentStatiBits.NEW.bit)) {
        return [
          {
            options: [
              {
                label: this.$t("signedDocuments.actions.addFiles"),
                method: (data) => {
                  this.addFiles(data);
                },
                doNotShowActiveState: true,
              },
              {
                label: this.$t("signedDocuments.actions.startSigningProcess"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("actions.delete"),
                method: (data) => {
                  this.deleteDocument(data);
                },
                color: "text-danger",
                doNotShowActiveState: true,
              },
            ],
          },
        ];
      } else if (this.$h.globalIsBitSet(this.item.status, this.signedDocumentStatiBits.READY_TO_SIGN.bit)) {
        return [
          {
            options: [
              {
                label: this.$t("signedDocuments.actions.addFiles"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("signedDocuments.actions.startSigningProcess"),
                method: (data) => {
                  this.thisStartSigningProcess(data);
                },
                doNotShowActiveState: true,
              },
              {
                label: this.$t("actions.delete"),
                method: (data) => {
                  this.deleteDocument(data);
                },
                color: "text-danger",
                doNotShowActiveState: true,
              },
            ],
          },
        ];
      } else if (this.$h.globalIsBitSet(this.item.status, this.signedDocumentStatiBits.INIT_SIGNING.bit)) {
        return [
          {
            options: [
              {
                label: this.$t("signedDocuments.actions.addFiles"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("signedDocuments.actions.startSigningProcess"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("actions.delete"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
            ],
          },
        ];
      } else if (
        this.$h.globalIsBitSet(this.item.status, this.signedDocumentStatiBits.WAITING_ON_SIGNATURES.bit) &&
        this.item.signable
      ) {
        return [
          {
            options: [
              {
                label: this.$t("signedDocuments.actions.addFiles"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("signedDocuments.actions.restartSigningProcess"),
                method: (data) => {
                  this.thisRestartSigningProcess(data);
                },
                doNotShowActiveState: true,
              },
              {
                label: this.$t("signedDocuments.actions.signDocuments"),
                method: (data) => {
                  this.redirectToSigningPage(data);
                },
                doNotShowActiveState: true,
                disabled: !this.showSignAction,
              },
              {
                label: this.$t("actions.delete"),
                method: (data) => {
                  this.deleteDocument(data);
                },
                color: "text-danger",
                doNotShowActiveState: true,
              },
            ],
          },
        ];
      } else if (
        this.$h.globalIsBitSet(this.item.status, this.signedDocumentStatiBits.WAITING_ON_SIGNATURES.bit) &&
        !this.item.signable
      ) {
        return [
          {
            options: [
              {
                label: this.$t("signedDocuments.actions.addFiles"),
                method: () => {},
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("signedDocuments.actions.signDocuments"),
                method: (data) => {
                  this.redirectToSigningPage(data);
                },
                doNotShowActiveState: true,
                disabled: true,
              },
              {
                label: this.$t("actions.delete"),
                method: (data) => {
                  this.deleteDocument(data);
                },
                color: "text-danger",
                doNotShowActiveState: true,
              },
            ],
          },
        ];
      }
    },
  },
  watch: {
    signedDocument: {
      deep: true,
      handler: function (val) {
        const vm = this;
        vm.$nextTick(() => {
          this.item = val;
        });
      },
    },
  },
};
</script>
